import { render, staticRenderFns } from "./BasicSidebar.vue?vue&type=template&id=562b836c"
import script from "./BasicSidebar.vue?vue&type=script&lang=js"
export * from "./BasicSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports